export default {"src":"/_next/static/media/project.694bb32a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};